import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapValues } from 'lodash';
import { templateParserJSX } from "../../../../../../../../../utils/strings";
export var processOfferVarsAndText = function processOfferVarsAndText(content) {
  var _vars = mapValues(content.offer.vars, function (v) {
    if (typeof v === 'string') return v;
    return _objectSpread(_objectSpread({}, v), {}, {
      'aria-label': v.children,
      mode: 'inline',
      style: {
        display: 'inline-flex'
      },
      tagName: 'a',
      target: '_blank',
      onClick: function onClick() {}
    });
  });
  return templateParserJSX(content.offer.text, _vars);
};